(function(){
  'use strict';
  var root=document.querySelector('[data-flexplay-root]');
  if(!root) return;
  var dialog=root.querySelector('.intro__dialog');
  var choicesWrap=root.querySelector('[data-flexplay-choices]');
  var verdict=root.querySelector('[data-flexplay-verdict]');
  var title=root.querySelector('[data-flexplay-verdict-title]');
  var copy=root.querySelector('[data-flexplay-verdict-copy]');
  var winTexts=Array.prototype.slice.call(root.querySelectorAll('[data-win-text]'));
  var cards=Array.prototype.slice.call(root.querySelectorAll('[data-win-card]'));
  var ball=root.querySelector('[data-flexplay-ball]');
  var status=root.querySelector('[data-flexplay-status]');
  var actions=root.querySelector('[data-flexplay-actions]');
  var cta=root.querySelector('[data-flexlearn-demo-open]');
  var STORAGE_KEY='flexlearn_play_seen_v44';
  var lastFocus=null;
  var timers=[];

  var data={
    onboarding:{title:'Your quickest win: get new hires productive sooner.',copy:'A guided onboarding journey gives every new starter a clear path while managers see progress without chasing updates.',points:['Role-based onboarding paths','Fewer manual follow-ups','Earlier manager visibility'],interest:'Onboarding / Talent'},
    skills:{title:'Your quickest win: make learning easier to prove.',copy:'Bring required learning, assessments and evidence into one trackable experience so completion is simpler for employees and reporting is simpler for HR.',points:['Clear learning paths','Assessments & certification','Audit-ready completion data'],interest:'Corporate Training'},
    engagement:{title:'Your quickest win: make learning worth coming back to.',copy:'Turn passive training into a more active experience with progress, challenges and recognition that people can actually feel.',points:['Higher learner participation','Visible progress & recognition','More memorable content'],interest:'Gamified Learning Content'},
    visibility:{title:'Your quickest win: replace chasing with clarity.',copy:'Bring learning activity, skills gaps and outcomes into one view so HR and managers can act sooner and spend less time building reports.',points:['Live progress dashboards','Skills-gap visibility','Less spreadsheet admin'],interest:'Enterprise LMS / LXP'}
  };

  function setSeen(){try{localStorage.setItem(STORAGE_KEY,'1')}catch(e){}}
  function hasSeen(){try{return localStorage.getItem(STORAGE_KEY)==='1'}catch(e){return true}}
  function clearTimers(){while(timers.length){window.clearTimeout(timers.pop())}}
  function later(fn,ms){var id=window.setTimeout(fn,ms);timers.push(id);return id}

  function hardUnlock(){
    document.documentElement.classList.remove('intro-on');
    document.body.classList.remove('intro-on');
    document.documentElement.style.overflow='';
    document.body.style.overflow='';
  }

  function openPlay(auto){
    lastFocus=document.activeElement;
    root.hidden=false;
    root.style.display='grid';
    root.setAttribute('aria-hidden','false');
    root.classList.remove('is-closing');
    document.documentElement.classList.add('intro-on');
    document.body.classList.add('intro-on');
    if(auto) setSeen();
    later(function(){try{dialog.focus({preventScroll:true})}catch(e){dialog.focus()}},30);
  }

  function closePlay(e){
    if(e){e.preventDefault();e.stopPropagation()}
    clearTimers();
    root.classList.add('is-closing');
    hardUnlock();
    later(function(){
      root.hidden=true;
      root.style.display='none';
      root.setAttribute('aria-hidden','true');
      root.classList.remove('is-closing');
      if(lastFocus&&typeof lastFocus.focus==='function'){try{lastFocus.focus({preventScroll:true})}catch(err){lastFocus.focus()}}
    },220);
  }

  function resetCards(){
    cards.forEach(function(card){
      card.classList.remove('is-unlocked','is-bursting');
      Array.prototype.slice.call(card.querySelectorAll('.intro-confetti')).forEach(function(el){el.remove()});
    });
    if(ball){
      ball.classList.remove('is-bouncing');
      ball.style.left='6%';
      ball.style.top='0.25rem';
    }
    if(status) status.textContent='Unlocking your first win…';
    if(actions){actions.classList.remove('is-visible')}
  }

  function makeConfetti(card){
    var colors=['#ffb20b','#143f72','#2db9ff','#ff6b6b','#7bd389','#9b6bff'];
    for(var i=0;i<18;i++){
      var bit=document.createElement('i');
      bit.className='intro-confetti';
      var angle=(Math.PI*2*i)/18;
      var distance=42+(i%5)*9;
      bit.style.setProperty('--cx',(Math.cos(angle)*distance).toFixed(1)+'px');
      bit.style.setProperty('--cy',(Math.sin(angle)*distance).toFixed(1)+'px');
      bit.style.setProperty('--cr',(i*47%220)+'deg');
      bit.style.background=colors[i%colors.length];
      card.appendChild(bit);
    }
    card.classList.add('is-bursting');
    later(function(){card.classList.remove('is-bursting');Array.prototype.slice.call(card.querySelectorAll('.intro-confetti')).forEach(function(el){el.remove()})},850);
  }

  function animateBallTo(index,done){
    if(!ball){done();return}
    var targets=['16.666%','50%','83.333%'];
    var target=targets[index];
    ball.classList.remove('is-bouncing');
    void ball.offsetWidth;
    var from=ball.style.left||'6%';
    if(ball.animate){
      var anim=ball.animate([
        {left:from,top:'2.6rem',transform:'translate(-50%,0) scale(1,1)'},
        {left:target,top:'0rem',transform:'translate(-50%,0) scale(.96,1.08)',offset:.62},
        {left:target,top:'2.6rem',transform:'translate(-50%,0) scale(1.12,.86)',offset:.86},
        {left:target,top:'1.6rem',transform:'translate(-50%,0) scale(1,1)'}
      ],{duration:620,easing:'cubic-bezier(.45,.05,.25,1)',fill:'forwards'});
      anim.onfinish=function(){ball.style.left=target;ball.style.top='1.6rem';done()};
    }else{
      ball.style.left=target; ball.style.top='1.6rem'; later(done,620);
    }
  }

  function unlockSequentially(){
    var labels=['First win unlocked ✓','Second win unlocked ✓','All three wins unlocked ✦'];
    function unlock(i){
      if(i>=cards.length){
        if(status) status.textContent='3 wins unlocked — now imagine this momentum across your whole team.';
        if(actions) actions.classList.add('is-visible');
        return;
      }
      animateBallTo(i,function(){
        cards[i].classList.add('is-unlocked');
        makeConfetti(cards[i]);
        if(status) status.textContent=labels[i];
        later(function(){unlock(i+1)},520);
      });
    }
    later(function(){unlock(0)},220);
  }

  function showVerdict(key){
    var item=data[key]; if(!item) return;
    clearTimers();
    title.textContent=item.title;
    copy.textContent=item.copy;
    winTexts.forEach(function(el,index){el.textContent=item.points[index]||''});
    cta.setAttribute('data-flexlearn-interest',item.interest);
    choicesWrap.hidden=true;
    choicesWrap.style.display='none';
    verdict.hidden=false;
    verdict.classList.remove('is-revealing');
    resetCards();
    void verdict.offsetWidth;
    verdict.classList.add('is-revealing');
    later(function(){unlockSequentially()},120);
    later(function(){try{verdict.scrollIntoView({behavior:'smooth',block:'nearest'})}catch(e){}},80);
  }

  function resetPlay(e){
    if(e){e.preventDefault();e.stopPropagation()}
    clearTimers();
    verdict.hidden=true;
    verdict.classList.remove('is-revealing');
    choicesWrap.hidden=false;
    choicesWrap.style.display='grid';
    winTexts.forEach(function(el){el.textContent='' });
    resetCards();
  }

  root.addEventListener('click',function(e){
    var close=e.target.closest('[data-flexplay-close]');
    if(close){closePlay(e);return}
    var choice=e.target.closest('.intro-choice');
    if(choice){e.preventDefault();showVerdict(choice.getAttribute('data-key'));return}
    if(e.target.closest('[data-flexplay-reset]')){resetPlay(e);return}
    var demo=e.target.closest('[data-flexlearn-demo-open]');
    if(demo){closePlay();}
  });

  document.addEventListener('click',function(e){
    var trigger=e.target.closest('[data-flexlearn-play-intro]');
    if(!trigger) return;
    e.preventDefault();e.stopPropagation();setSeen();resetPlay();openPlay(false);
  });

  document.addEventListener('keydown',function(e){if(!root.hidden&&e.key==='Escape')closePlay(e)});

  var url=new URL(window.location.href);
  if(url.searchParams.get('flexintro')==='1'){
    url.searchParams.delete('flexintro');
    try{history.replaceState({},'',url.pathname+url.search+url.hash)}catch(e){}
    later(function(){resetPlay();openPlay(false)},250);
  } else if(document.body.classList.contains('template-index')&&!hasSeen()){
    later(function(){resetPlay();openPlay(true)},1500);
  }

  window.FlexLearnPlay={open:function(){setSeen();resetPlay();openPlay(false)},close:closePlay,reset:resetPlay};
  window.addEventListener('pageshow',hardUnlock);
})();
